import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { MaskedLine, Reveal, SectionNumber } from "./Reveal";

const WHATSAPP_URL =
    "https://wa.me/971563141428?text=" +
    encodeURIComponent(
        "Hello NOMAS, I would like to discuss a sustainability/project opportunity.",
    );

export const Contact = () => (
    <section
        id="contact"
        data-testid="contact-section"
        className="relative overflow-hidden py-28 md:py-44"
    >
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_100%,rgba(124,191,82,0.14)_0%,transparent_70%)]" />
        <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
            <SectionNumber n="06" label="Contact" />
            <h2 className="font-display max-w-4xl text-5xl font-light leading-[1.05] tracking-tighter text-[#0E1112] sm:text-6xl lg:text-8xl">
                <MaskedLine>Let&rsquo;s Build Something</MaskedLine>
                <MaskedLine delay={0.15} className="text-[#C8102E]">
                    That Matters.
                </MaskedLine>
            </h2>
            <Reveal delay={0.25}>
                <p className="mt-8 max-w-md text-base leading-relaxed text-[#45543F] md:text-lg">
                    Have a challenge, project or opportunity? Let&rsquo;s
                    discuss it.
                </p>
                <p
                    className="mt-6 text-xs font-bold uppercase tracking-[0.28em] text-[#598B3B]"
                    data-testid="contact-positioning"
                >
                    NOMAS — Integrated Services and Solutions Provider
                </p>
            </Reveal>

            <div className="mt-16 grid gap-12 lg:grid-cols-[1fr_auto] lg:items-end">
                <Reveal delay={0.3}>
                    <div className="flex flex-col gap-1 border-t border-[#DCE5D4]" data-testid="contact-details">
                        <div className="flex items-center gap-5 border-b border-[#DCE5D4] py-6">
                            <MapPin size={18} className="shrink-0 text-[#598B3B]" strokeWidth={1.4} />
                            <div>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-[#8CA093]">Location</p>
                                <p className="font-display mt-1 text-lg font-light text-[#0E1112]">United Arab Emirates</p>
                            </div>
                        </div>
                        <a
                            href="tel:+971563141428"
                            data-testid="contact-phone"
                            className="group flex items-center gap-5 border-b border-[#DCE5D4] py-6"
                        >
                            <Phone size={18} className="shrink-0 text-[#598B3B]" strokeWidth={1.4} />
                            <div>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-[#8CA093]">Phone / WhatsApp</p>
                                <p className="font-display mt-1 text-lg font-light text-[#0E1112] transition-colors duration-300 group-hover:text-[#598B3B]">
                                    +971 56 314 1428
                                </p>
                            </div>
                        </a>
                        <a
                            href="mailto:gm@nomas-co.com"
                            data-testid="contact-email"
                            className="group flex items-center gap-5 border-b border-[#DCE5D4] py-6"
                        >
                            <Mail size={18} className="shrink-0 text-[#598B3B]" strokeWidth={1.4} />
                            <div>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-[#8CA093]">Email</p>
                                <p className="font-display mt-1 text-lg font-light text-[#0E1112] transition-colors duration-300 group-hover:text-[#598B3B]">
                                    gm@nomas-co.com
                                </p>
                            </div>
                        </a>
                    </div>
                </Reveal>

                <Reveal delay={0.4}>
                    <div className="flex flex-col gap-4 sm:flex-row lg:flex-col">
                        <a
                            href="mailto:gm@nomas-co.com?subject=Sustainability%20%2F%20Project%20Opportunity"
                            data-testid="contact-email-btn"
                            className="group flex items-center justify-between gap-8 rounded-full bg-[#598B3B] px-9 py-4 text-[13px] font-semibold uppercase tracking-[0.14em] text-white transition-[transform,background-color] duration-400 hover:-translate-y-0.5 hover:bg-[#4a7530]"
                        >
                            Email NOMAS
                            <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-whatsapp-btn"
                            className="group flex items-center justify-between gap-8 rounded-full border border-[#598B3B]/60 px-9 py-4 text-[13px] font-semibold uppercase tracking-[0.14em] text-[#0E1112] transition-[transform,background-color,border-color] duration-400 hover:-translate-y-0.5 hover:border-[#598B3B] hover:bg-[#598B3B]/10"
                        >
                            WhatsApp Us
                            <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
